import Vue from "vue";

export default {
	state: {
		version: "",
		actualUser: {},
		isUserLoaded: false
	},
	mutations: {
		setActualUserOnState(state, actualUser) {
			if (actualUser?.isClient) {
				localStorage.setItem("clientId", JSON.stringify(actualUser.idClient));
			}

			if (actualUser?.subdomain) {
				localStorage.setItem("subdomain", actualUser.subdomain);
			}

			state.isUserLoaded = true;
			state.actualUser = actualUser;
		},
		setVersion(state, version) {
			state.version = version;
		}
	},
	actions: {
		login({ commit }, user) {
			this.state.login = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("Authentication/token", user, { ignoreRefresh: true })
					.then((response) => {
						const responseData = response?.data?.data;
						if (response?.data?.isError) {
							this.state.loading = false;
							return reject(responseData?.code || "Erro desconhecido");
						}

						commit("setActualUserOnState", responseData);

						this.state.loading = false;
						resolve(responseData);
					})
					.catch((error) => {
						console.error("Erro na requisição:", error);
						this.state.loading = false;
						const errorMessage = error?.response?.data?.error?.message || "Erro desconhecido";
						reject(errorMessage);
					});
			});
		},
		loginUnico({ commit }, tokenData) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("Authentication/loginUnico", tokenData, { ignoreRefresh: true })
					.then((response) => {
						commit("setActualUserOnState", response.data.data);

						if (response?.data?.isError) {
							this.state.loading = false;
							return reject(response.data.data || "Erro desconhecido");
						}

						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch((error) => {
						this.state.loading = false;
						const errorMessage = error?.response?.data?.error?.message || "Erro desconhecido";
						reject(errorMessage);
					});
			});
		},
		refreshToken() {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post(
						"Authentication/token/refresh",
						{ idClient: JSON.parse(localStorage.getItem("clientId")) },
						{ ignoreRefresh: true }
					)
					.then(() => {
						this.state.loading = false;
						resolve();
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		sendPasswordEmail(_, login) {
			this.state.login = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("email/password", login, { ignoreRefresh: true })
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error.response.data.error.message);
					});
			});
		},
		resetPasswordEmail(_, data) {
			this.state.login = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("Authentication/password/email/reset", data, { ignoreRefresh: true })
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error.response.data.error.message);
					});
			});
		},
		resetPassword(_, data) {
			this.state.login = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("Authentication/password/reset", data, { ignoreRefresh: true })
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error.response.data.error.message);
					});
			});
		},
		getVersion({ commit }) {
			this.state.login = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("Authentication/version")
					.then((response) => {
						let responseVersion = response.data.data;
						commit("setVersion", responseVersion);
						resolve(responseVersion);
					})
					.catch((error) => {
						if (error) {
							console.error(error);
							reject(error.response.data.error.message);
						}
					});
			});
		},
		assumeIdentity({ commit }, data) {
			this.state.login = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("Authentication/assume", data, { ignoreRefresh: true })
					.then((response) => {
						commit("setActualUserOnState", response.data.data);
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error.response.data.error.message);
					});
			});
		},
		returnToOriginalIdentity({ commit }, data) {
			this.state.login = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("Authentication/return", data, { ignoreRefresh: true })
					.then((response) => {
						commit("setActualUserOnState", response.data.data);
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error.response.data.error.message);
					});
			});
		},
		checkToken() {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("Authentication/check")
					.then((response) => {
						const { authenticated } = response.data.data;
						if (response.data.isError) {
							return reject(false);
						}

						resolve(authenticated);
					})
					.catch(() => {
						reject(false);
					});
			});
		},
		logout({ state }) {
			return new Promise((resolve) => {
				Vue.prototype.$http
					.post("Authentication/logout")
					.then(() => {
						Vue.prototype.$functions.clearLocalStorage();
						state.actualUser = {};
						state.isUserLoaded = false;
						resolve();
					})
					.catch(() => {
						Vue.prototype.$functions.clearLocalStorage();

						state.actualUser = {};
						state.isUserLoaded = false;
						resolve();
					});
			});
		}
	},
	getters: {
		actualUser({ actualUser }) {
			return actualUser;
		},
		actualUserIsClient({ actualUser }) {
			if (!actualUser) return false;

			return actualUser?.isClient;
		},
		version({ version }) {
			return version;
		}
	}
};
